const getWebPFileName = (name = "image") => {
  const baseName = name.replace(/\.[^/.]+$/, "");
  return `${baseName || "image"}.webp`;
};

export const convertImageToWebP = (
  file,
  { maxWidth = 1920, quality = 0.82 } = {}
) =>
  new Promise((resolve) => {
    if (!file || !file.type?.startsWith("image/") || file.type === "image/webp") {
      resolve(file);
      return;
    }

    const image = new Image();
    const objectUrl = URL.createObjectURL(file);

    image.onload = () => {
      const scale = Math.min(1, maxWidth / image.width);
      const width = Math.round(image.width * scale);
      const height = Math.round(image.height * scale);
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      canvas.width = width;
      canvas.height = height;
      context.drawImage(image, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          URL.revokeObjectURL(objectUrl);

          if (!blob) {
            resolve(file);
            return;
          }

          resolve(
            new File([blob], getWebPFileName(file.name), {
              type: "image/webp",
              lastModified: Date.now(),
            })
          );
        },
        "image/webp",
        quality
      );
    };

    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(file);
    };

    image.src = objectUrl;
  });

export const convertImagesToWebP = (files, options) =>
  Promise.all(Array.from(files || []).map((file) => convertImageToWebP(file, options)));
